import { gql } from "graphql-request";

const SERVER_GET_AVERAGE = gql`
  query ($id: ID!) {
    average: getAverage(id: $id)
  }
`

export default SERVER_GET_AVERAGE;
